module.exports = __webpack_public_path__ + "static/media/history_4.b7769991.jpg";